import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { Chunk } from '@/types';

export function useGetChunk(caseId: string | null | undefined, chunkId: string | null) {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Chunk, Error>(
    [QueryEntity.Chunk, chunkId],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/thread/chunk/${chunkId}`, fetchConfigGET);
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    },
    { refetchOnWindowFocus: false, enabled: !!chunkId && !!caseId },
  );
}
